import React from 'react'
// components
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub,FaInstagram} from 'react-icons/fa'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href="https://www.linkedin.com/in/abhishek-yadav-142a03225/" target={'_blank'}><BsLinkedin /></a>
        <a href="https://github.com/Abhishek-Yadav-web" target={'_blank'}><FaGithub /></a>
        <a href="https://www.instagram.com/__labhishek/" target={'_blank'}><FaInstagram /></a>
    </div>
  )
}

export default HeaderSocials